import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import MasterLayout from "../masterLayout/MasterLayout";
import CustomRescuersFormPageUpdate from "../components/CustomRescuersFormPageUpdate";

const CustomRescuersFormUpdate = () => {
  const { id } = useParams(); // Get the id from the URL parameters

  return (
    <div>
      <MasterLayout>
        <CustomRescuersFormPageUpdate rescuerId={id} /> {/* Pass rescuerId as a prop */}
      </MasterLayout>
    </div>
  );
};

export default CustomRescuersFormUpdate;